import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { LegalEntityAction } from '../../constants';
import { LegalEntityActionType, LegalEntityStateType } from '../../types';

export const initialState: LegalEntityStateType = {
  search: { account: '', name: '' },
  legalEntities: [],
  selectedLegalEntities: [],
  accounts: [],
  loadingLegalEntities: false,
  currentPage: 1,
  totalCount: 0,
  error: '',
};

const reducer: Reducer<LegalEntityStateType, LegalEntityActionType> = produce(
  (draft: Draft<LegalEntityStateType>, action: LegalEntityActionType) => {
    const { type } = action;

    switch (type) {
      case LegalEntityAction.SEARCH_BY_NAME: {
        const { name } = action;
        draft.currentPage = 1;
        draft.search.name = name;
        break;
      }
      case LegalEntityAction.SET_LEGAL_ENTITIES: {
        const { legalEntities, count, error } = action;
        draft.legalEntities = legalEntities;
        draft.totalCount = count;
        draft.error = error;
        break;
      }
      case LegalEntityAction.SET_ACCOUNTS: {
        const { accounts } = action;
        draft.accounts = accounts;
        break;
      }
      case LegalEntityAction.SET_LOADING_LEGAL_ENTITIES: {
        const { loading } = action;
        draft.loadingLegalEntities = loading;
        break;
      }
      case LegalEntityAction.SEARCH_BY_ACCOUNT: {
        const { account } = action;
        draft.currentPage = 1;
        draft.search.account = account;
        break;
      }
      case LegalEntityAction.SET_SELECTED_LEGAL_ENTITIES: {
        const { selectedLegalEntities } = action;
        draft.selectedLegalEntities = selectedLegalEntities;
        break;
      }
      case LegalEntityAction.PAGINATE: {
        const { page } = action;
        draft.currentPage = page;
        break;
      }
    }
  },
  initialState
);

export const useLegalEntityReducer = (): [LegalEntityStateType, Dispatch<LegalEntityActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
